import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot, UrlSerializer } from '@angular/router';

export function isChildRoute(route: ActivatedRouteSnapshot, reference: ActivatedRouteSnapshot): boolean {
  const routeUrl = getResolvedUrl(route);
  const referenceUrl = getResolvedUrl(reference);

  const routeParts = routeUrl.split('/').filter(Boolean);
  const referenceParts = referenceUrl.split('/').filter(Boolean);
  const haveCommonPath = referenceParts[0] === routeParts[0];

  if (referenceUrl === routeUrl) {
    return Object.values(route.queryParams).length > Object.values(reference.queryParams).length;
  }

  return haveCommonPath && routeParts.length > referenceParts.length;
}

export function isParentRoute(route: ActivatedRouteSnapshot, reference: ActivatedRouteSnapshot): boolean {
  const routeUrl = getResolvedUrl(route);
  const referenceUrl = getResolvedUrl(reference);

  const routeParts = routeUrl.split('/').filter(Boolean);
  const referenceParts = referenceUrl.split('/').filter(Boolean);
  const haveCommonPath = referenceParts[0] === routeParts[0];

  if (referenceUrl === routeUrl) {
    return Object.values(route.queryParams).length < Object.values(reference.queryParams).length;
  }

  return haveCommonPath && routeParts.length < referenceParts.length;
}

export function getResolvedUrl(route: ActivatedRouteSnapshot): string {
  const urlSerializer = inject(UrlSerializer);
  return urlSerializer.serialize(createUrlTreeFromSnapshot(route, ['.']));
}
